import {updateFactory, Dispatch, AnyAction} from '@modifi/redux'
import {getAuthenticatedAdminThemisClient} from '@modifi/onboarding-api-clients'
import {aAddSnackBar} from '@modifi/plugin-snackbars'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import {keyWindowFromUrlForTasks} from '../../utils/keyWindowFromUrl'
import {AppThunkAction} from '../../types/redux'
import {aFetchTasksWithParams} from '../../data/tasks'

export const aFetchTasksWithUrlParams =
  (): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const params = keyWindowFromUrlForTasks(getState())
    if (Object.keys(params).length > 0 && !Number.isNaN(params?.pageIndex)) {
      dispatch(aFetchTasksWithParams(params))
    } else {
      // eslint-disable-next-line no-console
      console.warn('trying to fetch tasks with invalid params', JSON.stringify(params))
    }
  }

const apiClient = getAuthenticatedAdminThemisClient()

const {actions, reducer, selectors} = updateFactory({
  rootSelector: state => state?.pages?.tasks,
  actionNamePrefix: 'pages/tasks',
  submitRequest:
    (a, externalTaskId: string, changes: Record<string, any>, actionMessage?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
      dispatch(a.pendingAction())
      try {
        await apiClient.Task.update({
          externalTaskId,
          body: changes,
        })
      } catch (e: any) {
        dispatch(a.errorAction(e))
        return
      }
      // eslint-disable-next-line no-prototype-builtins
      if (Object.keys(changes).length === 1 && changes.hasOwnProperty('internalNote')) {
        dispatch(aCloseDialog())
      }

      dispatch(aFetchTasksWithUrlParams() as unknown as AnyAction)
      dispatch(a.successAction())
      actionMessage &&
        dispatch(
          aAddSnackBar({
            type: 'info',
            message: actionMessage,
          }) as unknown as AnyAction
        )
    },
})

export default reducer
export const {aSubmit, aReset} = actions
export const {selectUpdatePending, selectUpdateHasError, selectUpdateErrorMessage} = selectors
